import { render, staticRenderFns } from "./MoleculeInitialSetup.vue?vue&type=template&id=3bcd6d2a&"
import script from "./MoleculeInitialSetup.vue?vue&type=script&lang=js&"
export * from "./MoleculeInitialSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports